import { jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
const LazyLeftMenuDrawerContent = /*#__PURE__*/ lazy(()=>import("./LeftMenuDrawerContent.js"));
const LeftMenuDrawerContent = (props)=>/*#__PURE__*/ jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ jsx(LazyLeftMenuDrawerContent, {
            ...props
        })
    });
const LeftMenuDrawer_LazyLeftMenuDrawerContent = LeftMenuDrawerContent;
export default LeftMenuDrawer_LazyLeftMenuDrawerContent;
